import {
  Box,
  Grid,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  IconButton
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetUserCountries,
  setState,
  getScenariosForCountry,
  getPeriods,
  getCommentsAndAttachments,
  ExportAuditData,
  DownloadFile
} from "./auditSlice";
import CustomButton from "../../components/ui/CustomButton";
import Alert from "../../components/ui/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { DataGrid } from "@mui/x-data-grid";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GridOnIcon from "@mui/icons-material/GridOn";

export default function CommentsAndAttachments() {

  const dispatch = useDispatch();
  const audit = useSelector((state) => state.audit);
  const {
    countries,
    selectedCountry,
    selectedCountryID,
    scenarios,
    periods,
    selectedPeriod,
    selectedScenarioID,
    isLoading,
    commentsAndAttachmentsData,
    showOrHideExport,
    selectedScenarioName,
    showCommentsAndAttachments,
  } = audit;

  const [validate, setValidate] = useState({
    countryValidated: false,
    scenarioValidated: false,
    periodValidated: false
  });

  const [alert, setAlert] = useState({
    alertSeverity: "",
    alertDisplay: false,
    alertMessage: ""
  });

  const columns = [
    { field: "module", headerName: "Module", flex: 0.7 },
    {
      field: "createdDateTime", headerName: "Date(DDMMYYYY HH:MM:SS)", flex: 0.7, headerClassName: "wrapHeader",

      sortComparator: (v1, v2) => {
        const parseDate = (dateString) => {
          const [day, month, year, hour, minute, second, millisecond] = dateString.split(/[\s:]/);
          const months = {
            Jan: '01', Feb: '02', Mar: '03', Apr: '04', May: '05', Jun: '06',
            Jul: '07', Aug: '08', Sep: '09', Oct: '10', Nov: '11', Dec: '12'
          };
          return new Date(`${year}-${months[month]}-${day}T${hour}:${minute}:${second}.${millisecond}`);
        };
        return parseDate(v1) - parseDate(v2);
      },


      // valueFormatter: (params) => {
      //   const date = new Date(
      //     params.value.slice(7, 11) + '-' + params.value.slice(3, 6) + '-' + params.value.slice(0, 2) + 'T' + params.value.slice(12, 20).replace(':', '.')
      //   );
      //   return date.toLocaleString();
      // }
    },
    { field: "section", headerName: "Section", flex: 0.7 },
    { field: "scenarioName", headerName: "Scenario Name", flex: 0.7 },
    { field: "sku", headerName: "SKU", flex: 1 },
    { field: "customerName", headerName: "Customer", flex: 0.7 },
    // {
    //   field: 'attachment',
    //   headerName: 'Attachment',
    //   flex: 1.3,
    //   renderCell: (params) => (
    //     <a
    //       href="#"
    //       onClick={(e) => {
    //         e.preventDefault();
    //         handleDownloadFile(params.row.attachment);
    //       }}
    //     >
    //       {params.row.attachment}
    //     </a>
    //   ),
    // },
    {
      field: 'attachment',
      headerName: 'Attachment',
      flex: 1.3,
      renderCell: (params) => {
        const attachments = params.row.attachment.split('|');
        return (
          <div>
            {attachments.map((attachment, index) => (
              <a
                key={index}
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleDownloadFile(attachment);
                }}
                style={{ display: 'block', marginBottom: '5px' }}
              >
                {attachment}
              </a>
            ))}
          </div>
        );
      },
    },

    //{ field: "attachment", headerName: "Attachments", flex: 1 },
    //{ field: "comments", headerName: "Comments", flex: 2 }

    // {
    //   field: 'comments',
    //   headerName: 'Comments',
    //   width: 300,
    //   flex: 2,
    //   renderCell: (params) => (
    //     <div dangerouslySetInnerHTML={{ __html: params.value }} />
    //   ),
    // },


    {
      field: 'C1',
      headerName: 'Comments',
      flex: 2,
      renderCell: (params) => {
        const raw = String(params.row.comments ?? "");
        // Replace multiple <br/> tags with a single one (same as before)
        const cleanedValue = raw.replace(/(<br\/>\s*){2,}/g, "<br/>");
        const segments = cleanedValue.split(/<br\s*\/?>/i);
        return (
          <div>
            {segments.map((segment, index) => (
              <React.Fragment key={index}>
                {index > 0 ? <br /> : null}
                {segment}
              </React.Fragment>
            ))}
          </div>
        );
      },
    }
  ];


  const cleanComments = (comments) => {
    return comments.replace(/(<br\s*\/?>\s*)+/gi, '\n');
  };

  const cleanedData = commentsAndAttachmentsData.map(item => ({
    ...item,
    comments: cleanComments(item.comments)
  }));


  const generateExportData = () => {
    return cleanedData?.map((item) => {
      return item;
    });
  }

  useEffect(() => {
    dispatch(setState("showCommentsAndAttachments", false));
    dispatch(setState("selectedCountry", ""));
    dispatch(setState("selectedCountryID", ""));
    dispatch(setState("selectedScenarioName", ""));
    dispatch(setState("selectedScenarioID", ""));
    dispatch(setState("selectedPeriod", ""));
    dispatch(setState("scenarios",[]));
    dispatch(GetUserCountries({ method: "Get" }));
    dispatch(setState("showOrHideExport", false));
    dispatch(getPeriods());
  }, []);

  useEffect(() => {
    if (selectedCountryID !== "") {
      //console.log("The selected countryid is", selectedCountryID);
      getScenarios();
    }
  }, [selectedCountryID]);

  function getScenarios() {
    const countryID = selectedCountryID;
    dispatch(getScenariosForCountry({ countryID }));
  }

  useEffect(() => {
    const isAnyKeyValueFalse = (o) => !!Object.keys(o).find((k) => !o[k]);
    if (isAnyKeyValueFalse(validate)) {
      setAlert({ ...alert, alertDisplay: false });
    }
  }, [validate]);

  const displayAlert = (severityType) => {
    setAlert({
      alertSeverity: "warning",
      alertDisplay: true,
      alertMessage: `Please select the ${severityType}`
    });
  };

  const setCountry = (event) => {
    dispatch(setState("showCommentsAndAttachments", false));
    dispatch(setState("selectedScenarioName", ""));
    dispatch(setState("selectedScenarioID", ""));
    dispatch(setState("selectedPeriod", ""));

    const name = event.target.value;
    const countryID = countries.find((country) => country.countryName === name).countryID;

    if (name) {
      setValidate({ ...validate, countryValidated: true });
    }

    dispatch(setState("selectedCountry", name));
    dispatch(setState("selectedCountryID", countryID));
  };

  const setScenario = (event) => {
    dispatch(setState("showScenarioAuditData", false));
    const name = event.target.value;
    const selectedScenario = scenarios.find((scenario) => scenario.scenarioID === name);

    if (selectedScenario) {
      setValidate({ ...validate, scenarioValidated: true });
    }

    dispatch(setState("selectedScenarioName", selectedScenario.scenarioName));
    dispatch(setState("selectedScenarioID", selectedScenario.scenarioID));
  };

  const setPeriod = (event) => {
    dispatch(setState("showScenarioAuditData", false));
    const period = event.target.value;

    if (period) {
      setValidate({ ...validate, periodValidated: true });
    }

    dispatch(setState("selectedPeriod", period));
  };

  const handleDisplay = () => {
    const obj = {
      scenarioID: selectedScenarioID,
      period: selectedPeriod
    };

    //console.log("The object inside search is", obj);

    if (!validate.countryValidated) {
      displayAlert("Country");
    } else if (!validate.scenarioValidated) {
      displayAlert("Scenario");
    } else if (!validate.periodValidated) {
      displayAlert("Period");
    } else {
      dispatch(getCommentsAndAttachments(obj));
      dispatch(setState("showCommentsAndAttachments", true));
    }
  }

  const exportDataAsFile = async (isPdf) => {
    const obj = {
      isPdf,
      selectedCountry,
      selectedScenarioName,
      selectedPeriod,
      exportData: generateExportData(),
      exportTab: "Comments_Attachments"
    };
    //console.log("The object inside exportDataAsFile",obj);
    dispatch(ExportAuditData(obj));
  };

  const handleDownloadFile = (filepath) => {
    dispatch(DownloadFile(filepath));
  }



  return (
    <Box sx={{ mt: 3 }}>
      <Box>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={isLoading}
        >
          <CircularProgress />
        </Backdrop>
      </Box>

      <Grid container spacing={2} alignItems="center">
        <Grid item>
          <FormControl>
            <InputLabel>Country</InputLabel>
            <Select
              value={selectedCountry}
              label="Country"
              style={{ width: "300px" }}
              sx={{ color: "black.main", mt: 1 }}
              onChange={setCountry}
            >
              {countries.map((country, index) => (
                <MenuItem key={index} value={country.countryName}>
                  {country.countryName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item>
          <FormControl>
            <InputLabel>Scenario</InputLabel>
            <Select
              value={selectedScenarioID}
              label="Scenario"
              style={{ width: "300px" }}
              sx={{ color: "black.main", mt: 1 }}
              onChange={setScenario}
            >
              {(selectedCountryID ? scenarios :[])?.map((scenario, index) => (
                <MenuItem key={index} value={scenario.scenarioID}>
                  {scenario.scenarioName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item>
          <FormControl>
            <InputLabel>Period</InputLabel>
            <Select
              value={selectedPeriod}
              label="Period"
              style={{ width: "300px" }}
              sx={{ color: "black.main", mt: 1 }}
              onChange={setPeriod}
            >
              {periods?.map((period, index) => (
                <MenuItem key={index} value={period.value}>
                  {period.value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item sx={{ flexGrow: 1 }}>
          <CustomButton onClick={handleDisplay} size="large" style={{ width: "100px", height: "42px" }}>
            Search
          </CustomButton>
        </Grid>

        {showOrHideExport && (
          <Grid item>
            <Box display="flex" alignItems="center">
              <IconButton onClick={() => exportDataAsFile(false)}>
                <GridOnIcon sx={{ color: "green.main" }} />
              </IconButton>
              <IconButton onClick={() => exportDataAsFile(true)}>
                <PictureAsPdfIcon sx={{ color: "red.main" }} />
              </IconButton>
            </Box>
          </Grid>
        )}
      </Grid>

      {alert.alertDisplay && <Alert message={alert.alertMessage} severity={alert.alertSeverity} />}

      {showCommentsAndAttachments && (
        <Box mt={4}
          sx={{
            width: "100%",
            minHeight: "200px",
          }}>
          <DataGrid
            disableColumnMenu
            sx={{
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "grey.lighter"
              },
              "& .MuiDataGrid-cell": {
                whiteSpace: "normal !important",
                wordWrap: "break-word !important",
                padding: "10px",
                display: "flex",
                alignItems: "left",
              },
              "& .MuiDataGrid-row": {
                minHeight: "65px !important",
              },
              "& .MuiDataGrid-overlay": {
                zIndex: 10,
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                fontSize: "1rem",
                color: "#888",
              },
            }}
            style={{ maxHeight: "calc(100vh - 130px)", position: "relative", }}
            rows={commentsAndAttachmentsData || []}
            getRowId={(row) => row?.id}
            columns={columns}
            getRowHeight={() => "auto"}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 20,
                },
              },
            }}
            pageSizeOptions={[20, 50, 100]}
            disableRowSelectionOnClick
          />
        </Box>
      )}
    </Box>
  );
}
